export default __webpack_public_path__ + "0a302b471fc88b6f0f02bc80ad88a68e.png";